"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cc = void 0;
/** The list that the base of ego type. */
exports.default = Object.freeze([
    'application',
    'association',
    'development',
    'expression',
    'finance',
    'investment',
    'organization',
    'quest',
    'selfMind',
    'selfReliance',
]);
/** A table of LifeBase to CC. */
exports.cc = Object.freeze({
    application: 'G',
    association: 'I',
    development: 'D',
    expression: 'C',
    finance: 'E',
    investment: 'F',
    organization: 'H',
    quest: 'J',
    selfMind: 'B',
    selfReliance: 'A',
});
//# sourceMappingURL=lifeBase.js.map